// Outline heart, 20×20, for the Save pill; `filled` paints the inside (the saved state).
export default ({ size = "20", stroke = "#111111", filled = false, fill = "none" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 17.5C10.8333 17.5 18.3333 13.314 18.3333 7.45356C18.3333 2.92226 12.6354 0.551375 10 4.52284C7.36006 0.544566 1.66667 2.91816 1.66667 7.45356C1.66667 13.314 9.16667 17.5 10 17.5Z"
      stroke={stroke}
      fill={filled ? fill : "none"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
